import { ROUTE_DOCS_PROJECTS } from '@/common/constants';
import Filter from '@/components/filter/Filter';
import { Sidebar } from '@/components/sidebar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useProjectStore from '../store/useProjectStore';

export const ProjectWrapper: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { projects, projectsLoading } = useProjectStore();

  return (
    <div className="w-full h-screen overflow-hidden">
      <div className="flex">
        <Sidebar
          isLand={false}
          items={projects.content || []}
          isLoading={projectsLoading}
          totalPages={projects.totalPages || 1}
          totalElements={projects.totalElements}
        />
        <ScrollArea className="w-full  bg-gray-100 ">
          <Filter
            page={ROUTE_DOCS_PROJECTS}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            className={'border-b border-gray-200 py-2 pr-10 pl-6 bg-white'}
          />
          <ScrollArea className="h-[calc(100vh-95px)]">
            <Outlet />
          </ScrollArea>
        </ScrollArea>
      </div>
    </div>
  );
};
